var StringUtilities = /** @class */ (function () {
    function StringUtilities() {
    }
    StringUtilities.camelize = function (str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
            if (+match === 0) {
                return "";
            }
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    };
    StringUtilities.trimWhiteSpace = function (str) {
        return str.replace(/^\s+|\s+$/g, '');
    };
    StringUtilities.trimLeadingZeros = function (str) {
        return str.replace(/^0+/, '');
    };
    StringUtilities.endsWith = function (str, searchStr) {
        var _toString = Object.prototype.toString;
        var thisStr = String(StringUtilities.checkObjectCoercible(str));
        if (_toString.call(searchStr) === '[object RegExp]')
            throw new TypeError('Cannot call method "endsWith" with a regex');
        searchStr = String(searchStr);
        var thisLen = thisStr.length;
        var posArg = arguments.length > 2 ? arguments[2] : undefined;
        var pos = posArg === undefined ? thisLen : StringUtilities.toInteger(posArg);
        var end = Math.min(Math.max(pos, 0), thisLen);
        return thisStr.slice(end - searchStr.length, end) === searchStr;
    };
    StringUtilities.startsWith = function (str, searchStr) {
        var _toString = Object.prototype.toString;
        var thisStr = String(StringUtilities.checkObjectCoercible(str));
        if (_toString.call(searchStr) === '[object RegExp]')
            throw new TypeError('Cannot call method "startsWith" with a regex');
        searchStr = String(searchStr);
        var startArg = arguments.length > 2 ? arguments[2] : undefined;
        var start = Math.max(StringUtilities.toInteger(startArg), 0);
        return thisStr.slice(start, start + searchStr.length) === searchStr;
    };
    StringUtilities.escapeRegExp = function (string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
    };
    StringUtilities.isFinite = function (value) {
        // 1. If Type(number) is not Number, return false.
        if (typeof value !== 'number') {
            return false;
        }
        // 2. If number is NaN, +∞, or −∞, return false.
        if (value !== value || value === Infinity || value === -Infinity) {
            return false;
        }
        // 3. Otherwise, return true.
        return true;
    };
    StringUtilities.isNaN = function (o) {
        return o !== o;
    };
    StringUtilities.checkObjectCoercible = function (x) {
        if (x == null)
            throw TypeError('Cannot call method on ' + x);
        return x;
    };
    StringUtilities.isSign = function (x) {
        x = Number(x);
        if (x === 0 || isNaN(x)) {
            return x;
        }
        return x > 0 ? 1 : -1;
    };
    StringUtilities.toInteger = function (value) {
        var number = +value;
        if (StringUtilities.isNaN(number))
            return 0;
        if (number === 0 || !StringUtilities.isFinite(number))
            return number;
        return StringUtilities.isSign(number) * Math.floor(Math.abs(number));
    };
    return StringUtilities;
}());
export { StringUtilities };
